import { customFieldBuilderDe } from './custom-field-builder-i18n';
import { translationCenterDe } from './translation-center-i18n';
import { backupCenterDe, backupRestoreDe } from './backup-center-i18n';

/** Übersetzungen des Administrationsbereichs; eingebunden über lib/i18n/de.ts. */
export const adminDe = {
  nav: {
    label: 'Administration',
    system: 'System & Telemetrie',
    errorLogs: 'Fehlerzentrale',
    customFields: 'Zusatzfelder',
    auditVault: 'GoBD-Audit-Vault',
    dataHub: 'Import & Export',
    mailBackups: 'Mailversand',
    backups: 'Backup-Center',
    whatsapp: 'WhatsApp',
    telephonyAi: 'Telefonie & KI',
  },
  errorLogs: {
    title: 'Fehlerzentrale',
    subtitle: 'Zentral protokollierte Systemfehler mit vollständigem Kontext.',
    loadError: 'Die Fehlerprotokolle konnten nicht geladen werden.',
    emptyTitle: 'Keine Fehler protokolliert',
    emptyHint: 'Zu den gewählten Filtern liegen keine Einträge vor.',
    kpi: {
      unresolved: 'Offene Fehler',
      last24h: 'Letzte 24 Stunden',
    },
    filters: {
      search: 'Suche',
      searchPlaceholder: 'Referenz-ID, Meldung oder Endpunkt',
      httpStatus: 'HTTP-Status',
      from: 'Von',
      to: 'Bis',
      unresolvedOnly: 'Nur ungelöste Fehler',
      reset: 'Filter zurücksetzen',
    },
    columns: {
      timestamp: 'Zeitpunkt',
      status: 'Status',
      trackingId: 'Referenz-ID',
      user: 'Benutzer',
      endpoint: 'Endpunkt',
      message: 'Meldung',
      state: 'Bearbeitung',
    },
    state: {
      open: 'Offen',
      resolved: 'Gelöst',
    },
    detail: {
      title: 'Fehlerdetails',
      ip: 'IP-Adresse',
      client: 'Client',
      message: 'Meldung',
      context: 'Fachlicher Kontext',
      payload: 'Anfragedaten',
      payloadHint: 'Passwörter, Token und Bankverbindungen werden vor dem Speichern entfernt.',
      stackTrace: 'Stacktrace',
      notes: 'Notiz zur Behebung',
      resolved: 'Der Fehler wurde als behoben markiert.',
      reopened: 'Der Fehler wurde wieder geöffnet.',
      resolvedBy: 'Behoben von {{name}} am {{date}}.',
    },
    actions: {
      resolve: 'Als behoben markieren',
      reopen: 'Wieder öffnen',
      openDocument: 'Betroffenen Beleg öffnen',
      export: 'Support-Bericht exportieren',
    },
  },
  status: {
    OK: 'OK',
    WARNING: 'Warnung',
    CRITICAL: 'Kritisch',
  },
  system: {
    title: 'System & Telemetrie',
    subtitle: 'Laufzeit, Datenbank und Server im Überblick.',
    error: 'Die Telemetrie konnte nicht geladen werden.',
    refresh: 'Aktualisieren',
    application: 'Anwendung',
    database: 'Datenbank',
    server: 'Server',
    version: 'Version',
    commit: 'Commit',
    node: 'Node.js',
    environment: 'Umgebung',
    uptime: 'Laufzeit',
    heap: 'Heap',
    dbSize: 'Datenbankgröße',
    connections: 'Verbindungen',
    streamClients: 'Aktive Echtzeit-Clients',
    scheduler: 'Hintergrundläufe',
    schedulerStopped: 'Nicht aktiv',
    auditEntries: 'Protokolleinträge',
    cores: 'CPU-Kerne',
    loadAverage: 'Systemlast',
    memory: 'Arbeitsspeicher',
    backupDisk: 'Sicherungsspeicher',
    unavailable: 'Nicht verfügbar',
    collectedAt: 'Erhoben um',
    cpu: 'CPU-Auslastung',
    eventLoop: 'Event-Loop {{value}} ms',
    cacheHit: 'Cache-Trefferquote {{value}} %',
    gauges: 'Auslastung',
    gaugesHint: 'Die Werte aktualisieren sich alle 15 Sekunden.',
    features: 'Funktionen und Module',
    featuresHint: 'Effektive Verfügbarkeit, Konfigurationsfehler und pausierte Jobs.',
    featuresActive: 'Aktiv',
    featuresDisabled: 'Deaktiviert',
    featuresMisconfigured: 'Fehlkonfiguriert',
    featuresBlocked: 'Abhängigkeiten blockiert',
    featuresPausedJobs: 'Pausierte Jobs',
    featuresLastChanges: 'Letzte Feature-Änderungen',
    featuresNoChanges: 'Keine Änderungen protokolliert.',
    featureActive: 'aktiv',
    featureInactive: 'nicht aktiv',
    quickActions: 'Schnell-Aktionen',
    quickActionsHint: 'Wartungsarbeiten und Zwischenspeicher.',
    clearCache: 'Cache leeren',
    cacheCleared: '{{count}} zwischengespeicherte Dateien entfernt.',
    maintenanceMode: 'Wartungsmodus',
    maintenanceHint: 'Sperrt die Anwendung für alle außer den freigegebenen Adressen.',
    maintenanceMessage: 'Hinweistext',
    allowedIps: 'Freigegebene IP-Adressen',
    allowedIpsHint: 'Kommagetrennt, auch CIDR-Bereiche wie 10.0.0.0/8.',
    maintenanceSaved: 'Einstellungen gespeichert.',
  },
  customFields: {
    ...customFieldBuilderDe,
    translationCenter: translationCenterDe,
    title: 'Zusatzfelder',
    subtitle: 'Eigene Felder je Datenbereich, ohne Codeänderung.',
    create: 'Neues Zusatzfeld',
    created: 'Zusatzfeld angelegt.',
    updated: 'Zusatzfeld gespeichert.',
    archived: 'Zusatzfeld archiviert.',
    empty: 'Noch keine Zusatzfelder',
    emptyHint: 'Legen Sie ein Feld an, um zusätzliche Angaben zu erfassen.',
    dialogTitle: 'Zusatzfeld anlegen',
    editTitle: 'Zusatzfeld bearbeiten',
    edit: 'Bearbeiten',
    dialogDescription: 'Das Feld erscheint in den Masken für {{entity}}.',
    label: 'Anzeigename',
    key: 'Schlüssel',
    keyHint: 'Technischer Name; nach dem Anlegen unveränderlich.',
    description: 'Beschreibung',
    group: 'Kategorie',
    groupPlaceholder: 'Kategorie auswählen',
    type: 'Datentyp',
    pattern: 'Validierungs-Regex',
    patternHint: 'Optionale Formatprüfung, z. B. ^[A-Z]{2}\\d{4}$.',
    options: 'Auswahlwerte',
    optionLabel: 'Bezeichnung der Option',
    addOption: 'Option hinzufügen',
    removeOption: 'Option entfernen',
    noOptions: 'Noch keine Auswahlwerte',
    required: 'Pflichtfeld',
    inPdf: 'In PDF drucken',
    searchable: 'Suchbar',
    marketingSegmentationAllowed: 'Für Newsletter-Segmentierung freigeben',
    marketingSegmentationHint:
      'Nur aktivieren, wenn das Feld fachlich geprüft und nicht besonders sensibel ist.',
    inList: 'In Tabellen zeigen',
    inherit: 'In Folgebelege übernehmen',
    inheritHint: 'Wert wandert bei Angebot → Auftrag → Lieferschein → Rechnung automatisch mit.',
    inherited: 'Wird vererbt',
    inItemTable: 'In Positionstabelle einblenden',
    inItemTableHint: 'Erscheint als eigene Angabe unter der Positionszeile und im PDF.',
    copyFromProduct: 'Artikelwert in die Position übernehmen',
    copyFromProductHint:
      'Beim Hinzufügen des Artikels wird der Stammdatenwert in die Belegposition kopiert.',
    documentTypesTitle: 'Gültig für Belegtypen',
    documentTypesHint: 'Ohne Auswahl gilt das Feld für alle Belegtypen.',
    preview: 'Live-Vorschau',
    previewHint: 'So erscheint das Feld in der Eingabemaske.',
    previewLabel: 'Neues Feld',
    moveUp: 'Nach oben schieben',
    moveDown: 'Nach unten schieben',
    archive: 'Archivieren',
    archiveTitle: 'Zusatzfeld archivieren',
    archiveDescription: 'Das Feld „{{label}}“ wird ausgeblendet; erfasste Werte bleiben erhalten.',
    entities: {
      CUSTOMER: 'Geschäftspartner',
      CONTACT: 'Ansprechpartner',
      ADDRESS: 'Adressen und Lieferadressen',
      PRODUCT: 'Artikel',
      PRODUCT_PACKAGING: 'Artikelverpackungen',
      DOCUMENT: 'Beleg-Kopfdaten',
      DOCUMENT_ITEM: 'Beleg-Positionszeile',
      BATCH: 'Chargen',
    },
    documentTypes: {
      QUOTE: 'Angebot',
      ORDER: 'Auftrag',
      DELIVERY_NOTE: 'Lieferschein',
      INVOICE: 'Rechnung',
      PURCHASE_ORDER: 'Bestellung',
    },
    formula: {
      title: 'Formel',
      expression: 'Rechenausdruck',
      expressionHint:
        'Erlaubt sind + - * / Klammern, || für Ersatzwerte sowie abs, min, max, round, floor und ceil.',
      invalid: 'Die Formel ist ungültig.',
      unit: 'Einheit',
      unitHint: 'Erscheint hinter dem Ergebnis, z. B. €/Stk.',
      decimals: 'Nachkommastellen',
      testTitle: 'Live-Test',
      result: 'Ergebnis',
      variables: {
        title: 'Verfügbare Variablen – zum Einfügen anklicken',
        quantity: 'Menge',
        unitPrice: 'Einzelpreis',
        discountPercent: 'Rabatt %',
        taxRate: 'Steuersatz',
        lineNet: 'Zeilennetto',
        lineGross: 'Zeilenbrutto',
        lineTotal: 'Zeilensumme',
      },
    },
    types: {
      WEEKLY_SCHEDULE: 'Wochentage & Zeiten',
      TEXT: 'Text',
      TEXTAREA: 'Mehrzeiliger Text',
      NUMBER: 'Ganzzahl',
      DECIMAL: 'Dezimalzahl',
      DATE: 'Datum',
      CHECKBOX: 'Ja/Nein',
      SELECT: 'Auswahl',
      MULTI_SELECT: 'Mehrfachauswahl',
      FORMULA: 'Berechnetes Feld',
    },
  },
  auditVault: {
    title: 'GoBD-Audit-Vault',
    subtitle: 'Lückenlose, kryptografisch verkettete Änderungshistorie.',
    error: 'Das Protokoll konnte nicht geladen werden.',
    empty: 'Keine Einträge im gewählten Zeitraum.',
    integrityTitle: 'Integrität & Datenträgerüberlassung',
    integrityHint:
      'Die Prüfung rechnet jede Prüfsumme nach und meldet Abweichungen sowie fehlende Nummern.',
    verify: 'Hash-Kette prüfen',
    exportCsv: 'GoBD-Export (CSV)',
    exportXml: 'GDPdU-Export (XML)',
    exportReady: 'Export erstellt.',
    intact: 'Alle {{count}} Einträge sind unverändert.',
    broken: '{{count}} Integritätsbrüche festgestellt.',
    verifiedAt: 'Geprüft am {{timestamp}} in {{duration}} ms.',
    headHash: 'Kopf-Prüfsumme',
    filterEntity: 'Entität filtern',
    filterAction: 'Vorgang filtern',
    allEntities: 'Alle Entitäten',
    allActions: 'Alle Vorgänge',
    from: 'Von',
    to: 'Bis',
    timestamp: 'Zeitpunkt',
    action: 'Vorgang',
    entity: 'Entität',
    user: 'Benutzer',
    hash: 'Prüfsumme',
    previousHash: 'Vorgänger',
    origin: 'Herkunft',
    diffTitle: 'Protokolleintrag #{{sequence}}',
    field: 'Feld',
    before: 'Vorher',
    after: 'Nachher',
    noPayload: 'Zu diesem Vorgang liegen keine Nutzdaten vor.',
    changedFields: '{{count}} von {{total}} Feldern geändert.',
    actions: {
      INSERT: 'Angelegt',
      UPDATE: 'Geändert',
      DELETE: 'Gelöscht',
      LOCK: 'Festgeschrieben',
      EXPORT: 'Exportiert',
      REVERT: 'Zurückgenommen',
    },
    breaches: {
      HASH_MISMATCH: 'Prüfsumme stimmt nicht mit den Daten überein.',
      CHAIN_BROKEN: 'Verkettung zum Vorgänger unterbrochen.',
      SEQUENCE_GAP: 'Lücke in der laufenden Nummer.',
    },
    entities: {
      Customer: 'Kunde',
      Product: 'Artikel',
      ProductBatch: 'Charge',
      Document: 'Beleg',
      DocumentItem: 'Belegposition',
      StockMovement: 'Lagerbuchung',
      DatevExportLog: 'DATEV-Export',
      IntrastatExportLog: 'Intrastat-Export',
      CompanyProfile: 'Firmendaten',
      CustomFieldDefinition: 'Zusatzfeld',
      VatIdVerification: 'USt-ID-Prüfnachweis',
      DunningSettings: 'Mahneinstellungen',
      DunningStage: 'Mahnstufe',
      CustomerDunningPolicy: 'Kunden-Mahnkonditionen',
      DunningRun: 'Mahnlauf',
      DunningNotice: 'Mahnung',
      DunningNoticeSnapshot: 'Freigegebener Mahnsnapshot',
      DunningNoticeItem: 'Gemahnter offener Posten',
      DunningStatusEvent: 'Mahnstatus-Nachweis',
      DunningDispatch: 'Mahnversand-Nachweis',
      CustomerPayment: 'Kundenzahlung',
      CustomerPaymentAllocation: 'Zahlungszuordnung',
      VatValidationSettings: 'USt-ID-Prüfeinstellungen',
      ProductionLotGenealogyEdge: 'Chargengenealogie-Kante',
      RecallSimulation: 'Recall-Simulation',
      RecallSimulationAnchor: 'Recall-Startcharge',
      RecallSimulationAffectedBatch: 'Betroffene Recall-Charge',
      RecallSimulationOperation: 'Recall-Vorgang',
    },
  },
  dataHub: {
    title: 'Import & Export',
    subtitle: 'Stammdaten aus CSV- oder Excel-Dateien übernehmen.',
    step1: 'Datei wählen',
    step1Hint: 'CSV oder Excel per Ziehen und Ablegen oder über die Dateiauswahl.',
    step2: 'Spalten zuordnen',
    step2Hint: 'Gleichnamige Spalten sind bereits vorbelegt.',
    step3: 'Prüfen & importieren',
    step3Hint: 'Der Probelauf schreibt nichts in die Datenbank.',
    target: 'Zielbereich',
    dropHere: 'Datei hier ablegen',
    formats: 'Unterstützt werden .csv und .xlsx bis 10 MB.',
    chooseFile: 'Datei auswählen',
    uploaded: '{{fileName}} · {{rows}} Zeilen, {{columns}} Spalten erkannt.',
    sourceColumn: 'Quellspalte',
    sample: 'Beispielwerte',
    targetField: 'ERP-Feld',
    ignore: 'Nicht übernehmen',
    runDryRun: 'Probelauf starten',
    validRows: '{{count}} gültige Zeilen',
    invalidRows: '{{count}} fehlerhafte Zeilen',
    row: 'Zeile',
    field: 'Feld',
    reason: 'Grund',
    startImport: '{{count}} Zeilen importieren',
    imported: '{{success}} Datensätze angelegt, {{failed}} übersprungen.',
    history: 'Import-Historie',
    historyHint: 'Abgeschlossene Läufe lassen sich vollständig zurücknehmen.',
    noJobs: 'Noch keine Importläufe.',
    file: 'Datei',
    progress: 'Fortschritt',
    status: 'Status',
    executedAt: 'Abgeschlossen',
    rowSummary: '{{success}} übernommen · {{failed}} Fehler · {{total}} gesamt',
    rollback: 'Rückgängig',
    rolledBack: 'Import zurückgenommen.',
    entities: {
      CUSTOMER: 'Kundenstamm',
      PRODUCT: 'Artikelstamm',
      STOCK_ADJUSTMENT: 'Bestandskorrekturen',
    },
    statuses: {
      PENDING: 'Wartet',
      PROCESSING: 'Läuft',
      COMPLETED: 'Abgeschlossen',
      FAILED: 'Fehlgeschlagen',
      ROLLED_BACK: 'Zurückgenommen',
    },
  },
  backupCenter: backupCenterDe,
  backupRestore: backupRestoreDe,
  mailBackups: {
    title: 'Mailversand',
    subtitle: 'Postausgang und SMTP-Konfiguration prüfen.',
    smtpTitle: 'SMTP-Diagnose',
    smtpHint: 'Prüft Verbindung, Verschlüsselung und Anmeldung am Mailserver.',
    testConnection: 'Verbindung testen',
    sendTest: 'Testnachricht senden',
    recipient: 'Empfänger',
    testSent: 'Testnachricht versendet.',
    testFailed: 'Die Testnachricht konnte nicht versendet werden.',
    reachable: 'Erreichbar',
    unreachable: 'Nicht erreichbar',
    queueTitle: 'Fehlgeschlagene Belegmails',
    queueHint: 'Erneut senden lässt sich der Versand direkt am Beleg.',
    queueEmpty: 'Keine fehlgeschlagenen Sendungen.',
    document: 'Beleg',
    errorMessage: 'Fehler',
    attemptedAt: 'Versucht am',
    backupsTitle: 'Datensicherung',
    backupsHint: 'Verschlüsselte Archive (AES-256-GCM) im Sicherungsverzeichnis.',
    createNow: 'Jetzt Backup erstellen',
    backupCreated: 'Sicherung erstellt.',
    noBackups: 'Noch keine Sicherungen vorhanden.',
    archive: 'Archiv',
    size: 'Größe',
    createdAt: 'Erstellt am',
    checksum: 'Prüfsumme',
    download: 'Herunterladen',
    delete: 'Löschen',
    deleted: 'Sicherung gelöscht.',
    deleteTitle: 'Sicherung löschen?',
    deleteDescription:
      'Das Archiv "{{fileName}}" wird unwiderruflich vom Server entfernt. Bereits heruntergeladene Kopien bleiben erhalten.',
    writable: 'Verzeichnis beschreibbar',
    notWritable: 'Verzeichnis nicht beschreibbar',
    dumpAvailable: 'pg_dump verfügbar',
    dumpMissing: 'pg_dump fehlt — Sicherung läuft über den Host-Cron',
    cron: 'Zeitplan (Cron)',
    retention: 'Aufbewahrung (Tage)',
    storageTarget: 'Speicherziel',
    encrypted: 'Verschlüsseln',
    scheduleActive: 'Zeitplan aktiv',
    lastRun: 'Letzter Lauf: {{timestamp}} · {{status}}',
    targets: {
      LOCAL: 'Lokales Volume',
      S3: 'S3-kompatibel',
      OFFSITE_SSH: 'Externer SSH-Speicher',
    },
  },
} as const;
